export const FETCH_BUSINESS_COMPANY = 'FETCH_BUSINESS_COMPANY';
export const FILTER_BUSINESS_COMPANY = 'FILTER_BUSINESS_COMPANY';